import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM.75 12C.75 5.787 5.787.75 12 .75S23.25 5.787 23.25 12 18.213 23.25 12 23.25.75 18.213.75 12Z",
			fill: "#000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 11.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM9.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z",
			fill: "#000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 4.5a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V5.25A.75.75 0 0 1 12 4.5Zm.53 8.03a.75.75 0 0 1 1.061 0l2.69 2.69a.75.75 0 1 1-1.061 1.06l-2.69-2.689a.75.75 0 0 1 0-1.06Z",
			fill: "#000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M12%202.25c-5.385%200-9.75%204.365-9.75%209.75s4.365%209.75%209.75%209.75%209.75-4.365%209.75-9.75S17.385%202.25%2012%202.25ZM.75%2012C.75%205.787%205.787.75%2012%20.75S23.25%205.787%2023.25%2012%2018.213%2023.25%2012%2023.25.75%2018.213.75%2012Z%22%20fill%3D%22%23000%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%2F%3E%3Cpath%20d%3D%22M12%2011.25a.75.75%200%201%200%200%201.5.75.75%200%200%200%200-1.5ZM9.75%2012a2.25%202.25%200%201%201%204.5%200%202.25%202.25%200%200%201-4.5%200Z%22%20fill%3D%22%23000%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%2F%3E%3Cpath%20d%3D%22M12%204.5a.75.75%200%200%201%20.75.75v5.25a.75.75%200%200%201-1.5%200V5.25A.75.75%200%200%201%2012%204.5Zm.53%208.03a.75.75%200%200%201%201.061%200l2.69%202.69a.75.75%200%201%201-1.061%201.06l-2.69-2.689a.75.75%200%200%201%200-1.06Z%22%20fill%3D%22%23000%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
